// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__173dQ","descr":"Footer_descr__ZQ0Rh"};